if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      this.cartTermsNotification = this.querySelector('.cart-terms-notification');
      this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));
      this.submitHandler = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this.submitHandler);
      this.checkHandler = this.handleCheck.bind(this);
      this.cartTermsCheckbox.addEventListener('change', this.checkHandler);
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
      this.cartTermsCheckbox.removeEventListener('change', this.checkHandler);
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        this.classList.add('notification-error');
      }
    }
    handleCheck() {
      if (this.cartTermsCheckbox.checked) {
        this.classList.remove('notification-error');
      }
    }
  }
  customElements.define('cart-terms', CartTerms);
}
